<template>
	<form class="form-horizontal" @submit.prevent="save">
		<div class="animated fadeIn">
			<b-card class="min-vh-100">
				<div class="display-table full-width mb-2">
					<strong class="card-title">{{ $route.meta.label }}</strong>
				</div>
				<b-row>
					<b-col>
						<div class="my-4">
							<a :href="models.thumbnail" target="_blank">
								<b-img :src="getUrlOfFile(models.thumbnail)" fluid class="d-block m-auto"
									style="max-height: 300px" />
							</a>
						</div>
					</b-col>
				</b-row>
				<b-row>
					<b-col md="5">
						<div class="mb-4">
							<h6>Title</h6>
							<span class="text-capitalize">{{ models.title }}</span>
						</div>
						<div class="mb-4">
							<h6>Link</h6>
							<a :href="models.link" target="_blank">{{ models.link }}</a>
						</div>
						<div class="mb-4">
							<h6>Podcast Category</h6>
							<span class="text-capitalize">{{ models.podcast_category }}</span>
						</div>
					</b-col>
					<b-col md="5">
						<div class="mb-4">
							<h6>Publish Date</h6>
							<span class="text-capitalize">{{ moment(models.publish_date).format('DD - MM - YYYY') }}</span>
						</div>
						<div class="mb-4">
							<h6>Description</h6>
							<div v-html="models.description"></div>
						</div>
						<div class="mb-4">
							<h6>Status</h6>
							<span :class="'badge badge-' + getClassStatus(models.status)" class="text-capitalize">
								{{ models.status }}
							</span>
						</div>
					</b-col>
				</b-row>
				<template #footer>
					<b-button block type="button" variant="light" class="btn-min-width rounded float-left"
						@click="$router.push({ name: config.uri })">
						Cancel
					</b-button>
				</template>
			</b-card>
		</div>
	</form>
</template>
<script>
import moment from 'moment'
import api from '@/utils/api.js'
import { getClassStatus } from '@/utils/helpers';


import {
	getUrlOfFile
} from '@/utils/helpers.js';

export default {
	name: 'DetailPodcast',
	data() {
		return {
			config: {
				uri: this.$route.meta.permission.link,
			},
			models: {
				title: "",
				publish_date: "",
				podcast_category: "",
				description: "",
				thumbnail: "",
				link: "",
				status: "publish"
			},
			vars: {
				videoSrc: null,
				videoUrlActive: false,
				onLoadData: false
			},
			moment
		}
	},
	created() {
		let _ = this
		_.getById();
	},
	methods: {
		getById() {
			const _ = this;
			if (_.$route.params.id) {
				_.vars.onLoadData = true
				_.$axios.get(`${api.podcast}/${_.$route.params.id}`)
					.then(res => {
						const { data } = res.data;
						_.models.title = data.title,
							_.models.description = data.description,
							_.models.thumbnail = data.thumbnail,
							_.models.link = data.link,
							_.models.podcast_category = data.podcast_category ? data.podcast_category.name : '-',
							_.models.publish_date = moment(data.publish_date).format('YYYY-MM-DDTHH:mm'),
							_.models.status = data.status

						this.$nextTick(() => {
							_.vars.onLoadData = false
						});
					}).catch(() => {
						_.vars.onLoadData = false
						_.$router.push({
							name: 'page404'
						})
					});
			}
		},

		getClassStatus(status) {
			return getClassStatus(status);
		},

		getUrlOfFile(file) {
			return getUrlOfFile(file, true);
		},
	},
	computed: {},
	watch: {}
}
</script>